<template>
    <v-dialog persistent :value="modal_failed.active" max-width="600">
        <v-card class="pa-4">
            <v-icon class="modal-close" @click.native="show_results" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title class="display-1">{{ $t(modal_failed.modal_title) }}</v-card-title>
            <v-card-text class="title mt-4">{{ course_name }}</v-card-text>
            <v-layout row wrap pa-3
                      mb-4 mt-3
            >
                <v-flex xs12 sm6>
                    <v-layout align-center>
                        <v-flex
                          class="xs6"
                          v-html="$t('Набрано баллов {lineBreak}{pointsEarned} из {pointsTotal}', {
                            lineBreak: '<br>',
                            pointsEarned: points_earned_test,
                            pointsTotal: points_total_test,
                          })"
                        />
                        <v-flex>
                            <v-progress-circular
                                :rotate="-90"
                                :size="64"
                                :width="6"
                                :value="percent(points_earned_test,points_total_test)"
                                :class="points_earned_test >= points_required_test ? 'green-text' : 'red-text'"
                            >
                                {{ percent(points_earned_test,points_total_test) }}%
                            </v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-layout align-center :class="{'mt-4': $vuetify.breakpoint.xs}">
                        <v-flex
                          class="xs6"
                          v-html="$t('Проходной балл {lineBreak}{scoreRequired} из {scoreMax}', {
                            lineBreak: '<br>',
                            scoreRequired: points_required_test,
                            scoreMax: points_total_test,
                          })"
                        />
                        <v-flex>
                            <v-progress-circular
                                :rotate="-90"
                                :size="64"
                                :width="6"
                                :value="percent(points_required_test,points_total_test)"
                                class="grey-text"
                            >
                                {{ percent(points_required_test,points_total_test) }}%
                            </v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout>
                    <buttonRed class="mr-4" :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="show_results">{{ $t("Смотреть результаты") }}</buttonRed>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    buttonBdWhite,
  },
  props: {
    modal_type: {
      type: Object,
    },
  },
  mounted() {
    this.DISABLE_SNACKBAR();

    this.SET_STATE_COURSE({type: 'test_finished', items: true});
  },
  computed: {
    ...mapGetters('course_info', [
      'course_name',
      'points_total_test',
      'points_required_test',
      'points_earned_test',
    ]),
    ...mapGetters('course_info/modals', [
      'modal_success',
      'modal_failed',
      'modal_test',
    ]),
  },
  methods: {
    ...mapMutations('course_info', [
      'SET_STATE_COURSE',
    ]),
    ...mapMutations('course_info', [
      'DISABLE_SNACKBAR',
      'TOGGLE_SNACKBAR',
      'COMPLETE_COURSE',
    ]),
    ...mapMutations('course_info/modals', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapMutations('testing/questions', [
      'SHOW_RESULTS',
    ]),
    ...mapActions('course_info/steps', [
      'next_step',
    ]),
    ...mapActions('testing', [
      'show_results',
    ]),
    percent: function(required, total) {
      if (required<total) {
        return Math.round((required/total)*100);
      } else return 100;
    },
  },
};
</script>
